import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const CartContext = createContext(null);

const STORAGE_KEY = 'cart_services';

const loadCart = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart debe usarse dentro de un CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [cartServices, setCartServices] = useState(loadCart);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(cartServices));
  }, [cartServices]);

  const addService = useCallback((service) => {
    setCartServices((prev) => {
      if (prev.some((s) => s.serviceId === service.serviceId)) return prev;
      return [...prev, service];
    });
  }, []);

  const removeService = useCallback((serviceId) => {
    setCartServices((prev) => prev.filter((s) => s.serviceId !== serviceId));
  }, []);

  const clearCart = useCallback(() => {
    setCartServices([]);
  }, []);

  const isServiceInCart = useCallback(
    (serviceId) => cartServices.some((s) => s.serviceId === serviceId),
    [cartServices]
  );

  return (
    <CartContext.Provider value={{ cartServices, addService, removeService, clearCart, isServiceInCart }}>
      {children}
    </CartContext.Provider>
  );
};
